import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useAuthStore } from '@/stores/auth';
import { useContextStore } from '@/stores/context';
import { useNavigate } from '@tanstack/react-router';
import { LogOut, Settings } from 'lucide-react';

export function UserMenu(): React.JSX.Element {
  const navigate = useNavigate();
  const { user, signOut } = useAuthStore();
  const resetContext = useContextStore((s) => s.reset);
  const initial = user?.name?.trim().charAt(0).toUpperCase() || user?.email?.charAt(0).toUpperCase() || 'U';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-9 gap-2 px-2" aria-label="Account">
          <span className="grid size-6 place-items-center rounded-full bg-secondary text-[10px] font-semibold">{initial}</span>
          <span className="hidden max-w-36 truncate text-xs font-medium sm:block">{user?.name || user?.email}</span>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end">
        <DropdownMenuLabel className="font-normal text-muted-foreground">{user?.email}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => void navigate({ to: '/settings' })}>
          <Settings className="size-4" />
          Settings
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={async () => {
            await signOut();
            // The persisted context points at another user's org ids. Leaving it would hand the
            // next person to sign in on this machine a switcher aimed at rows they cannot read.
            resetContext();
            await navigate({ to: '/login' });
          }}
        >
          <LogOut className="size-4" />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
